import { render, staticRenderFns } from "./benefits-tier-design-form.vue?vue&type=template&id=0304b4f1&scoped=true"
import script from "./benefits-tier-design-form.vue?vue&type=script&lang=js"
export * from "./benefits-tier-design-form.vue?vue&type=script&lang=js"
import style0 from "./benefits-tier-design-form.vue?vue&type=style&index=0&id=0304b4f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0304b4f1",
  null
  
)

export default component.exports